import { Component } from '@angular/core';

@Component({
  selector: 'app-mobile-warning',
  standalone: true,
  imports: [],
  templateUrl: './mobile-warning.component.html',
  styleUrl: './mobile-warning.component.scss'
})
export class MobileWarningComponent {

}
